import { ACTIONS } from 'a/pictureThis/data/constants';

export const initialState = {
  isShowingHint: false,
  nextCardAnimationTrigger: false,
};

const gamePanel = (state = initialState, { type, payload }) => {
  switch (type) {
    case ACTIONS.SELECT_LEVEL:
    case ACTIONS.SET_NORMAL_VIEW:
      return {
        ...state,
        isShowingHint: false,
      };
    case ACTIONS.START_NEXT_CARD_ANIMATION:
      return {
        ...state,
        nextCardAnimationTrigger: !state.nextCardAnimationTrigger,
      };
    case ACTIONS.SET_IS_SHOWING_HINT:
      return {
        ...state,
        isShowingHint: payload,
      };

    default:
      return state;
  }
};

export default gamePanel;

// selectors

export const getIsShowingHint = state => state.isShowingHint;

export const getNextCardAnimationTrigger = state => state.nextCardAnimationTrigger;
